import classNames from 'classnames'

import Leaderboard from '@/components/Layout/Leaderboard/Leaderboard'
import Sidebar from '@/components/Layout/Sidebar/Sidebar'
import { useTheme } from '@/components/ThemeProvider/ThemeProvider'
import { useAds } from '@/contexts/ads'
import useDirectories from '@/utils/useDirectories'

import styles from './Main.module.scss'

const GRADIENT_DARK = 'linear-gradient(to bottom, rgba(18, 19, 21, 0.5), rgba(18, 19, 21, 1))'
const GRADIENT_LIGHT = 'linear-gradient(to bottom, rgba(249, 250, 251, 0.5), rgba(249, 250, 251, 1))'

const LEADERBOARD_BLACKLIST = ['annamargaret', 'combo-vote']
const SIDEBAR_BLACKLIST = [
  'about-us',
  'account',
  'annamargaret',
  'apply',
  'bug-report',
  'confirm-password',
  'contact-us',
  'forgot-password',
  'newsletter',
  'privacy',
  'reset-password',
  'signin',
  'signup',
]
const ADHESION_WHITELIST = ['', ...SIDEBAR_BLACKLIST, 'articles']
//const VIDEO_AD_ENABLED = false

type Props = {
  artCrop?: string
  banner?: React.ReactNode
  children: React.ReactNode
  isGuide?: boolean
}

const Main = ({ artCrop, banner, children, isGuide }: Props) => {
  const { country, loadAds } = useAds()
  const { dir } = useDirectories()
  const [theme] = useTheme()

  const gradient = theme === 'dark' ? GRADIENT_DARK : GRADIENT_LIGHT
  const showAdhesion = loadAds !== false && ADHESION_WHITELIST.includes(dir)
  const showLeaderboard = loadAds !== false && !LEADERBOARD_BLACKLIST.includes(dir)
  const showSidebar = loadAds !== false && !SIDEBAR_BLACKLIST.includes(dir)

  return (
    <>
      {artCrop && (
        <div className={styles.backgroundContainer}>
          <div
            className={styles.background}
            style={{
              backgroundImage: `${gradient}, url(${artCrop})`,
            }}
          />
        </div>
      )}
      {banner && <div className={styles.backgroundContainer}>{banner}</div>}
      {/* {VIDEO_AD_ENABLED && (
        <div
          data-blocklist-universal-player-desktop='1'
          data-blocklist-universal-player-mobile='1'
          id='mediavine-settings'
        />
      )} */}
      <div className={styles.leftRight}>
        <main className={styles.main}>
          {showLeaderboard && <Leaderboard country={country} />}
          <div className={classNames('d-flex flex-grow-1 p-3', { 'pe-lg-0': showSidebar })}>
            <div className='d-flex flex-column w-100'>{children}</div>
          </div>
        </main>
        {showSidebar && <Sidebar country={country} isGuide={isGuide} />}
      </div>
      {/* {VIDEO_AD_ENABLED && loadAds && <VideoAd showingAdhesion={showAdhesion} />} */}

      {/* Ensure MV Desktop adhesion is disabled unless desired*/}
      {!showAdhesion && <div data-blocklist-adhesion-desktop='1' data-blocklist-adhesion-tablet='1' />}
    </>
  )
}

export default Main
